<app-wrapper size="lg">
  <div @enter *ngIf="(loaded$ | async) === true">
    <!-- 戻るボタン -->
    <app-content-row>
      <div class="flex items-center gap-x-2" *ngIf="this.selectedSearchCondition.tag !== undefined">
        <app-button-location-back (backClick)="goBack()">戻る</app-button-location-back>
      </div>
    </app-content-row>

    <!-- 検索条件 -->
    <app-content-row>
      <app-playlists-search-condition
        [subjects]="subjects$ | async"
        [selectedSearchCondition]="selectedSearchCondition"
      ></app-playlists-search-condition>
    </app-content-row>

    <!-- タグ一覧 -->
    <app-content-row>
      <app-playlists-tag-buttons [playlistsTags$]="playlistsTags$" (tagClick)="clickTag($event)"></app-playlists-tag-buttons>
    </app-content-row>

    <!-- 検索結果 -->
    <app-content-row>
      <app-playlists-search-result [playlists$]="playlists$" [searchCondition]="selectedSearchCondition"> </app-playlists-search-result>
    </app-content-row>

    <!-- 結果がない場合 -->
    <app-content-row *ngIf="(playlists$ | async)?.length === 0">
      <app-content-no-data>
        <span>おすすめ問題セットはありません</span>
      </app-content-no-data>
    </app-content-row>
  </div>
</app-wrapper>

<div class="progress-48" *ngIf="(loaded$ | async) === false">
  <mat-spinner [diameter]="48"></mat-spinner>
</div>
